export enum ImageBehavior {
  Cover = 'Cover',
  Fit = 'Fit',
}

interface TextEmptyImageState {
  $type: 'text';
}

interface AvatarEmptyImageState {
  $type: 'icon';
  iconName: string;
}

export type EmptyImageState = TextEmptyImageState | AvatarEmptyImageState;
